<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="800">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-ACCUMULATOR' : 'EDIT-ACCUMULATOR') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <!--Name-->
            <div class="col-8">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" *ngIf="name.hasError('required') && name.touched"
                        role="alert">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" *ngIf="name.hasError('nameExists')" role="alert">
                        {{'ACCUMULATOR-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
            <!--Start Date-->
            <div class="col-4">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'EFFECTIVE-DATE' | translate}} *
                    </span>
                    <kendo-datepicker formControlName="startDate">
                    </kendo-datepicker>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="startDate.hasError('required') && startDate.touched">
                        {{'EFFECTIVE-DATE-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <!--Description-->
        <div class="row">
            <div class="col-12">
                <label for="description" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'DESCRIPTION' | translate }}
                    </span>
                    <textarea id="description" kendoTextArea class="w-100 k-textarea" rows="2"
                        formControlName="description" maxlength="1000" style="max-height: 300px;">
                    </textarea>
                </label>
            </div>
        </div>
        <div class="row">
            <!--Max Units-->
            <div class="col-6">
                <label for="maxUnits" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'MAX-UNITS' | translate }}
                    </span>
                    <kendo-numerictextbox #maxUnitsControl [format]="'n0'" formControlName="maxUnits" [min]="0">
                    </kendo-numerictextbox>
                </label>
            </div>
            <!--Max Amount-->
            <div class="col-6">
                <label for="maxAmount" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'MAX-AMOUNT' | translate }}
                    </span>
                    <kendo-numerictextbox [format]="'n2'" formControlName="maxAmount" [min]="0">
                    </kendo-numerictextbox>
                </label>
            </div>
        </div>
        <div class="row">
            <!--Frequency-->
            <div class="col-6">
                <label for="frequency" class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'FREQUENCY' | translate }} *
                    </span>
                    <kendo-combobox class="w-100" formControlName="frequency" [data]="frequencies"
                        [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="false">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="frequency.hasError('required') && frequency.touched">
                        {{'REQUIRED-FREQUENCY' | translate}}
                    </div>
                </label>
            </div>
            <!--Duration-->
            <div class="col-6">
                <label for="duration" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'DURATION' | translate }}
                    </span>
                    <kendo-numerictextbox [format]="'n0'" formControlName="duration" [min]="1">
                    </kendo-numerictextbox>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <label class="k-text-uppercase dark mr-2 pt-3 w-100" for="validateMaximum">{{
                    'ACCUMULATOR-VALIDATE-MAXIMUM' | translate }}
                </label>
                <kendo-switch formControlName="validateMaximum" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
            <div class="col-6">
                <label class="k-text-uppercase dark mr-2 pt-3 w-100" for="allowNonConsecutive">{{'ACCUMULATOR-ALLOW-NON-CONSECUTIVE' | translate }}<span class="ml-1" style="display: inline-flex">
                        <div kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                          (focus)="showTooltip(tooltipPrivate)" (mouseover)="showTooltip(tooltipPrivate)"
                          (blur)="hideTooltip()" (mouseout)="hideTooltip()" aria-live="polite">
                          <a #tooltipPrivate title="{{'NONE-CONSECUTIVE-TOOLTIP' | translate}}">
                            <i class="fa fa-info-circle pointer"></i></a>
                        </div>
                      </span>
                </label>
                <kendo-switch formControlName="allowNonConsecutive" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <label class="k-text-uppercase dark mr-2 pt-3 w-100" for="enabled">{{ 'ENABLED' | translate }}</label>
                <kendo-switch formControlName="enabled" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>